<mat-tab-group [selectedIndex]="selectedIndex" (selectedIndexChange)="tabChanged($event)">
  <!-- Proposer Tab -->
  <mat-tab>
    <ng-template mat-tab-label>
      Proposer
    </ng-template>
    <div class="card-body">
      <app-breakdown-proposer-details
        [staticData]="staticData"
        [apiModelObject]="apiModelObject"
        (modelObjectUpdated)="modelObjectUpdated($event)"
        [authDetails]="authDetails"
      ></app-breakdown-proposer-details>
    </div>
  </mat-tab>

  <!-- Vehicles Tab -->
  <mat-tab>
    <ng-template mat-tab-label>
      Vehicles
    </ng-template>
    <div class="card-body">
      <app-breakdown-vehicles
        [staticData]="staticData"
        [modelObject]="modelObject"
        (modelObjectUpdated)="modelObjectUpdated($event)"
        [apiModelObject]="apiModelObject"
        [originalPolicyId]="originalPolicyId"
        [authDetails]="authDetails"
      ></app-breakdown-vehicles>
    </div>
  </mat-tab>

  <!-- Quotation Tab -->
  <mat-tab>
    <ng-template mat-tab-label>
      Quotation
    </ng-template>
    <div class="card-body">
      <app-breakdown-quotation
        [staticData]="staticData"
        [authDetails]="authDetails"
        [modelObject]="modelObject"
        (modelObjectUpdated)="modelObjectUpdated($event)"
        (BackToVehicles)="selectedIndex = 1"
        [apiModelObject]="apiModelObject"
        [originalPolicyId]="originalPolicyId"
        [selectedIndex]="selectedIndex"
      ></app-breakdown-quotation>
    </div>
  </mat-tab>
</mat-tab-group>
